import './dataSourceTypeItem.less'
import { getDataSourceImage } from '../../utils/dataSourceUtil'
import { DATA_SOURCE_TYPES, DATA_SOURCE_TYPE_API_MAP } from '../../constants'
import { DatasourceType } from '../../services/graphqlSchemaTypes'
import React, { ReactElement } from 'react'
import { Typography, TypographyProps } from '@lightbeamai/design-system'

interface IProps {
  className?: string
  textVariant?: TypographyProps['variant']
  textType?: TypographyProps['type']
  dataSourceType?: DATA_SOURCE_TYPES | DatasourceType
  content?: ReactElement | string
  sizePx?: number
  tooltip?: string
}

const DataSourceTypeItem = (props: IProps): React.ReactElement => {
  const {
    className,
    dataSourceType,
    content,
    sizePx = 18,
    tooltip = '',
    textVariant = 'base',
    textType = 'normal'
  } = props

  if (!dataSourceType) return <></>

  return (
    <div
      className={`data-source-item ${className}`}
      title={tooltip || dataSourceType}
      data-test-id="datasource-type-item"
    >
      <div className="icon-box" style={{ height: sizePx, width: sizePx }}>
        <img src={getDataSourceImage(dataSourceType, '/../../assets/images/dataSourceTypes/')} />
      </div>
      &nbsp;
      <Typography
        as="span"
        color="primary"
        variant={textVariant}
        type={textType}
        className="datasource-name truncate"
      >
        {content !== undefined ? content : DATA_SOURCE_TYPE_API_MAP[dataSourceType]}
      </Typography>
    </div>
  )
}

export default DataSourceTypeItem
